import { AuthenticationState } from "bernie-context";
import { ExtendedContextStore } from "src/typings/flexFramework/FlexDefinitions";

export function mapContext(context: ExtendedContextStore) {
  const {
    currency,
    deviceInformation,
    user: { authState, expUserId, isRegistered, tuid },
  } = context;

  const expediaUserId = expUserId && expUserId !== -1 ? expUserId.toString() : "";
  const publisherTuId = tuid && tuid !== -1 ? tuid.toString() : "";
  let displayFormatType = "Desktop";
  if (deviceInformation) {
    if (deviceInformation.tablet) {
      displayFormatType = "Tablet";
    } else if (deviceInformation.mobile) {
      displayFormatType = "Mobile";
    }
  }

  return {
    display_format_type: displayFormatType,
    is_logged_in_user: authState === AuthenticationState.ANONYMOUS ? "N" : "Y",
    is_member: isRegistered ? "Y" : "N",
    site_currency: currency || "",
    user_member_id: expediaUserId,
    member_id: publisherTuId,
    page_id: "homepage.hotels",
    trigger_exit_unit: "N",
    is_signed_up_for_promo_email: "N",
  };
}
